import { Link } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import routerPaths from '../util/routerPaths';
import { useAuth } from '../hooks/useAuth';

function TeamsConfig() {
  const data = useAuth();

  if (!data || !data.tenant) {
    return null;
  }

  const tenantKey = data.tenant.key;

  let extension = `?key=${tenantKey}`;
  if (tenantKey === null || Number.isNaN(tenantKey)) {
    extension = '';
  }
  const href = `https://dialin.plcm.vc/teams/ps.html${extension}`;

  const handleCustomizeClick = () => {
    scroll.scrollToTop();
    return routerPaths.SETTINGS;
  };

  if (data.tenant.hasTeams) {
    return (
      <>
        <hr />
        <b>
          <i>Teams Configuration</i>
        </b>
        <br />
        <br />
        <div style={{ marginLeft: '10px' }}>
          <label htmlFor="teamsVtcUri">Teams VTC URI:</label>
          &nbsp;<strong>{tenantKey}@t.plcm.vc</strong>
          <br />
          <Link to={handleCustomizeClick}>Teams Gateway Settings</Link>
          <br />
          <br />
          One-time configuration:
          <br />
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://dialin.plcm.vc/teams/preconsent.html"
          >
            Consent to RealConnect for Teams
          </a>
          <br />
          <a
            target="_blank"
            rel="noopener noreferrer"
            id="PowerShellUri"
            href={href}
          >
            PowerShell Instructions for RealConnect for Teams
          </a>
        </div>
      </>
    );
  }

  return null;
}

export default TeamsConfig;
